import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '@projects/App.vue'
import router from '@projects/router'

import { setupApplication } from '@shared/global'

const app = createApp(App)

// install global plugins and scripts
setupApplication(app)

// install page specific plugins
app.use(createPinia())
app.use(router)

// eslint-disable-next-line no-undef
console.debug('projects', BUILD_DATE_UTC) // defined in vite.config.js


app.mount('#app')
